/**
 * Normalizes in-app paths for navigation (e.g. obfuscated URLs).
 * Currently returns the path unchanged; extend here if routing rules change.
 */
export const toAppPath = (path) => path;
